import { Box } from '@chakra-ui/react';
import { MotionBox } from '@time-line/components/common';
import type { AspectRatio } from '@time-line/components/types';
import { AnimatePresence } from 'motion/react';
import { useEffect, useState } from 'react';
import type { ProductMedia } from 'types/cms/pages/ProductPage';

import { ProductGalleryMobileMediaItem } from './ProductGalleryMobileMediaItem';

const INSET_IMAGE_WIDTH = '100px';

interface InsetLayoutProps {
  media: [ProductMedia, ProductMedia];
  title: string;
  visibleIndex: number | null;
  aspectRatio?: AspectRatio;
}

export function ProductGalleryMobileInsetLayout({
  media,
  title,
  visibleIndex,
  aspectRatio = '1:1',
}: InsetLayoutProps) {
  const [[firstItem, secondItem], setItems] = useState<
    [ProductMedia, ProductMedia]
  >(() => [...media].reverse() as [ProductMedia, ProductMedia]);
  const [keyCounter, setKeyCounter] = useState(0);

  useEffect(() => {
    setItems([...media].reverse() as [ProductMedia, ProductMedia]);
    setKeyCounter(0);
  }, [media]);

  return (
    <Box
      position="relative"
      width="100%"
      maxW="100%"
      overflow="hidden"
      borderRadius="base"
      role="group"
    >
      <AnimatePresence>
        <MotionBox
          key={keyCounter}
          borderRadius="base"
          overflow="hidden"
          width="100%"
          position="relative"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.1 }}
        >
          <ProductGalleryMobileMediaItem
            galleryItem={firstItem}
            index={0}
            title={title}
            visibleIndex={visibleIndex}
            aspectRatio={aspectRatio}
          />
        </MotionBox>
      </AnimatePresence>
      <AnimatePresence>
        <MotionBox
          key={keyCounter + 1}
          position="absolute"
          bottom="xs"
          left="xs"
          width={INSET_IMAGE_WIDTH}
          borderRadius="base"
          overflow="hidden"
          zIndex={2}
          onClick={() => {
            setItems(([first, second]) => [second, first]);
            setKeyCounter((i) => i + 1);
          }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.1 }}
        >
          <ProductGalleryMobileMediaItem
            galleryItem={secondItem}
            index={0}
            title={title}
            visibleIndex={visibleIndex}
            isInset
            aspectRatio={aspectRatio}
          />
        </MotionBox>
      </AnimatePresence>
    </Box>
  );
}
